import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Interface (lo que recibes del backend)
 */
export interface TipoActorVial {
  id?: number;
  descripcion: string;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class TipoActorVialService {
  private apiUrl = `${environment.apiUrl}/api/tipo-actor-vial`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getTiposActorVial(): Observable<TipoActorVial[]> {
    return this.http
      .get<TipoActorVial[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener activos
  getTiposActorVialActivos(): Observable<TipoActorVial[]> {
    return this.http
      .get<TipoActorVial[]>(`${this.apiUrl}/activos`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getTipoActorVialById(id: string | number): Observable<TipoActorVial> {
    return this.http
      .get<TipoActorVial>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createTipoActorVial(payload: TipoActorVial): Observable<TipoActorVial> {
    return this.http
      .post<TipoActorVial>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateTipoActorVial(id: string | number, payload: TipoActorVial): Observable<TipoActorVial> {
    return this.http
      .put<TipoActorVial>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteTipoActorVial(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: string | number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
